import React from 'react'
import styled from 'styled-components'

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size === 'small' ? '24px' : size === 'large' ? '40px' : '32px'};
  height: ${({ size }) => size === 'small' ? '24px' : size === 'large' ? '40px' : '32px'};
  border-radius: ${({ theme }) => theme.radii.sm};
  border: 1px solid transparent;
  background: transparent;
  color: ${({ theme, variant }) => variant === 'danger' ? theme.colors.error : theme.colors.textSecondary};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme, variant }) => variant === 'danger' ? theme.colors.error + '1A' : theme.colors.background};
    color: ${({ theme, variant }) => variant === 'danger' ? theme.colors.error : theme.colors.text};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.primary}33;
  }
`

export function IconButton({ icon, onClick, variant, size = 'medium', ...props }) {
  return (
    <StyledButton onClick={onClick} variant={variant} size={size} {...props}>
      {icon}
    </StyledButton>
  )
}
